var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.53 26.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#21bdc3;stroke-miterlimit:10;stroke-width:0.43px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.26,16.88c4.22,0,7.65-3.74,7.65-8.33S17.48.22,13.26.22,5.62,4,5.62,8.55,9.05,16.88,13.26,16.88Zm0-14.16a5.61,5.61,0,0,1,5.35,5.83,5.61,5.61,0,0,1-5.35,5.82A5.6,5.6,0,0,1,7.92,8.55,5.61,5.61,0,0,1,13.26,2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.8,17.64a1.07,1.07,0,0,0-1.09.24l-2.45,2.25-2.44-2.25a1.07,1.07,0,0,0-1.09-.24C8.14,18.19.22,21.15.22,25.42a1.2,1.2,0,0,0,1.15,1.25H25.16a1.2,1.2,0,0,0,1.15-1.25C26.31,21.15,18.39,18.19,16.8,17.64ZM3.14,24.17c1.26-1.42,4.21-3,6.69-3.93l2.69,2.49a1.1,1.1,0,0,0,1.49,0l2.69-2.49c2.48.94,5.43,2.51,6.69,3.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.b75f7e5edc2e406c937c786578cd7daf.svg";
export { ForwardRef as ReactComponent };